import * as moment from 'moment-timezone';

export enum DayType {
    active,
    notActive,
}

export interface ICalendarDay {
    week: number;
    date: moment.Moment;
    type: DayType;
    isFromCurrentMonth: boolean;
}

export class CalendarSettings {
    // minDate: moment.Moment;
    // maxDate: moment.Moment;

    activeClass: string;
    notActive: string;
}
